<template>

	<card :title="title" id="frame">
		<div id="suchfeld">
				<v-text-field
          v-model="filterInput"
          append-icon="search"
					@click:append="fetchCustomers"
          label="Nach Name, Straße oder Firma suchen"
          required
          clearable
					v-on:keyup.enter="fetchCustomers"
        ></v-text-field>
			</div>
			<!-- <input class="form-control" placeholder="Nach Name, Straße oder Firma suchen" v-on:keyup.enter="fetchCustomers" v-model="filterInput">
			<button id="search" class="btn btn-primary btn-sm" v-on:click="fetchCustomers">Suchen</button> -->

	<br>
		<div class="table-responsive"  v-if="kunden.length">
		<table class="table table-striped table-hover">
			<thead>
				<tr>
					<th></th>
					<th>Name</th>
					<th>Firma</th>
					<th>Adresse</th>
          <th>Knr.</th>
				</tr>
			</thead>
			<tbody>
				<tr  v-for="kunde in kunden" :key="kunde.Kunden_Nr">
					<td><v-icon huge @click="pushInformation(kunde.Kunden_Nr)">info</v-icon></td>
					<td>{{kunde.Nachname}}</td>
					<td>{{kunde.Firma}}</td>
					<td>{{kunde.strassenr}}</td>
          <td>{{kunde.Kunden_Nr}}</td>
				</tr>
			</tbody>
		</table>
		</div>
	</card>
</template>

<script>
export default {
  name: 'Informationen',
  data () {
    return {
		auth: "Basic " + window.btoa(process.env.VUE_APP_NODE_AUTH),
		title:"Kundeninformationen abrufen ",
		kunden: [],
		searchItem: [],
		alarm:'',
		filterInput:'',
		datum:'',
		columns: ['Knr.', 'Name',	'Adresse', 'Firma'],
		sortKey: '',
    }
	},
	mounted() {


			// setTimeout(() => this.searchItem = this.kunden)
    },
	computed:{
      // filterKunden () {
			// 	 return this.kunden.filter((item) =>{
			// 		 if (item.Nachname){
			// 			return item.Nachname.toLowerCase().match(this.filterInput) || item.Firma.toLowerCase().match(this.filterInput) || item.Strasse.toLowerCase().match(this.filterInput)
			// 		 }
			//   });

			// 	 const self = this;
      // if (self.filterInput === '') {
      //   return self.kunden;
      // } else {
			// 	return self.searchItem.filter((kunde) => {
			// 		return kunde.Nachname.match(self.filterInput) > -1
			// 	});

					// self.filterKunden === kunde.Nachname;
					// return kunde.Nachname.toUpperCase().includes(self.filterInput.toUpperCase()) > -1;
					// console.log(kunde.Nachname)

      // }


        // return this.kunden.filter(kunde => {
       	// 	return kunde.Nachname.toLowerCase()
       	// 	.indexOf(this.filterInput.toLowerCase()) > -1;
				// });
      // }
    },
  methods: {
    fetchCustomers(){
      this.$http.get(process.env.VUE_APP_NODE_API_URL+'/heimspiel/search/'+this.filterInput, { headers: {'Authorization': this.auth }})
        .then(function(response){
          this.kunden.length = 0;

          for (var i = 0; i< response.body.data.length; i++){

            let Ergebnis = {
              Kunden_Nr: response.body.data[i].Kunden_Nr,
              Firma: response.body.data[i].Firma,
              Nachname: response.body.data[i].Nachname,
              Vorname: response.body.data[i].Vorname,
              Strasse: response.body.data[i].Strasse,
							Hausnummer: response.body.data[i].Hausnummer,
							strassenr: response.body.data[i].Strasse + " "+ response.body.data[i].Hausnummer,
              PLZ: response.body.data[i].PLZ,
              Bezirk: response.body.data[i].Bezirk,
              Stadt: response.body.data[i].Stadt,
              Telefon: response.body.data[i].Telefon,
              Telefon2: response.body.data[i].Telefon2,
              Typ: response.body.data[i].Typ,
              Schicht: response.body.data[i].Schicht,
              Bemerkung: response.body.data[i].Bemerkung
            }
            this.kunden.push(Ergebnis)
          }

          // this.kunden = response.body
        });

    },
    pushInformation(kundennummer){
      this.$router.push('/information/'+ kundennummer);
    },
		// filterBy(list,value){
		// 	if(this.filterInput.length > 0){
		// 	value = value.charAt(0).toUpperCase() + value.slice(1);
		// 	return list.filter(function(kunden){
		// 		return kunden.Nachname.indexOf(value) > -1;
		// 	});
		// 	}
		// }
	},
	created: function(){
		// this.fetchCustomers();
		// console.log(this.kunden)
	},
	updated: function(){
		// this.fetchCustomers();
	},
	// async mounted () {
  //   this.loaded = false
  //   // this.fetchKeywords().then()
  //   await this.$http.get('https://api.uhl.katsios-kesting.de/kunden' )
  //       .then(function(response){
  //         console.log(response);
  //             this.kunden = response.body;

  //        });
  // },
	components: {

	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#suchfeld{
	padding-left: 5px;
	padding-right: 5px;
}
.form-control{
	margin-bottom: 10px;
}
#frame{
    margin-left: 0%;
    margin-top: 0%;
    padding-left: 0%;
    padding-top: 0%;
    padding-right: 0%;

}
</style>

